<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="posts"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPosition.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
        <el-button type="primary" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="职位编号">
            <el-input v-model.trim="filter.postNO" clearable/>
          </vm-search>
          <vm-search label="职位名称">
            <el-input v-model.trim="filter.postName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="postNO" align="center" label="职位编号"/>
      <el-table-column prop="postName" align="center" label="职位名称"/>
      <el-table-column prop="parentName" align="center" label="上级职位"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="info" @click="$refs.editPosition.open(scope.row)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <position-edit ref="editPosition" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import PositionEdit from "@/views/information/Position/PositionEdit";
  export default {
    name: "PositionList",
    components: {PositionEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        exportLoading: false,
        filter: {
          postNO: "",
          postName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.postID);
          }
          console.log(ids);
          this.$http
            .delete("basic","posts/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","posts",row.postID).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },



      // exportExcel() {
      //   window.open(window.config.basicServerUrl + "posts/export");
      // },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","posts/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
